<template>
  <div>
    <v-dialog v-model="announcementDialog" scrollable persistent max-width="800">
      <v-card flat>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1" flat dark height="50px">
            <v-tooltip bottom v-if="announcementForm.title.length > 86">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 16px;
                  ">{{ announcementForm.title }}</span>
              </template>
              <span>{{ announcementForm.title }}</span>
            </v-tooltip>
            <span v-else style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
              ">{{ announcementForm.title }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="onClose" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="max-height: 60vh">
          <span v-html="$sanitizeHtml(announcementForm.content)"></span>
          <v-expansion-panels v-model="basicInfoPanels" focusable v-if="announcementForm.documents.length">
            <a-expansion-panel class="document-info-panel" @change="onPanelClick" >
              <v-expansion-panel-header disable-icon-rotate>
                <v-btn small color="primaryDark" dark icon class="mr-2" style="flex: 0 0 auto">
                  <v-icon color="primaryDark">mdi-file-multiple</v-icon>
                </v-btn>
                <span style="color: #333333;">{{ announcementForm.documents.length }} file(s)</span>
                <template v-slot:actions>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small color="grey" dark icon v-bind="attrs" v-on="on" >
                        <v-icon v-if="isPanelOpen()">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="isPanelOpen()">{{ $t("lblCollapse") }}</span>
                    <span v-else>{{ $t("lblExpand") }}</span>
                  </v-tooltip>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content id="document-panel" style="max-height: 200px; overflow-y: auto;">
                <v-list dense class="file-list" style="max-height: 180px">
                  <v-list-item dense v-for="(file, index) in announcementForm.documents" :key="index" link class="pt-0 pb-0">
                    <v-list-item-content
                      @click="documentDownload(file)">
                      <v-list-item-title style="line-height: 20px" :class="[
                        'downloadLink',
                        'label-m',
                      ]">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on" style="display: inline; color: #006cad">
                              {{ file.name }}
                            </div>
                          </template>
                          <p class="ma-0">
                            {{ $t("lblFileName") }} : {{ file.name }}
                          </p>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action style="flex-direction: row">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn x-small icon right color="neutralGray1" @click="documentDownload(file)" v-bind="attrs"
                            v-on="on" class="mr-3"><v-icon size="24">
                              mdi-download</v-icon></v-btn>
                        </template>
                        <span>{{ $t("agenda.tipSaveDoc") }}</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </a-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { openDocument } from "../../utils/util";
import Loader from "../Loader.vue";

export default {
  name: "ViewAnnouncement",
  components: {
    Loader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    announcementForm: {
      type: Object,
      default: () => { },
    },
  },

  data() {
    return {
      basicInfoPanel: true,
      basicInfoPanels: 0,
      Loaderloading: false,
      LoaderText: this.$t("LoaderText"),
    };
  },
  computed: {
    announcementDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument"
    }),
    onClose,
    onPanelClick(e) {
      let panelContentEl = document.getElementById('document-panel');
      if (e?.target?.classList.contains("v-expansion-panel-header--active")) {
        this.basicInfoPanel = false;
      } else {
        this.basicInfoPanel = true;
      }
      setTimeout(() => {
        if(panelContentEl && this.basicInfoPanel) {
          panelContentEl.style.overflowY = 'auto';
          panelContentEl.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }, 500);
    },
    async documentDownload(item) {
      if (item.action === "add") {
        this.showMessageSheet(this.$t("agenda.CannotOpenDocInfo"), "info");
      } else {
        const params = {
          documentId: item.documentId,
          filename: item.name,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = item.name;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    isPanelOpen() {
      if (this.basicInfoPanels || this.basicInfoPanels == 0) {
        return this.basicInfoPanels.toString();
      }
    },
  },
};

function onClose() {
  this.announcementDialog = false;
  this.$emit("input", false);
}
</script>

<style scoped>
.document-info-panel /deep/ .v-expansion-panel-content__wrap {
  padding: 12px !important;
}

.a-expansion-panel /deep/ .v-expansion-panel-header {
  background: white !important;
  border-radius: 8px 8px 0px 0px !important;
  border-top: thin solid rgba(0, 0, 0, .12);
  border-bottom: thin solid rgba(0, 0, 0, .12);
  font-weight: 700 !important;
  height: 48px !important;
}

.document-info-panel /deep/ .v-expansion-panel-header__icon {
  margin-left: 5px;
}

.document-info-panel .v-expansion-panel-header>*:not(.v-expansion-panel-header__icon) {
  flex: 0 0 auto;
}

.a-expansion-panel:not(.a-expansion-panel-pale-blue) .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
  color: grey !important;
}
</style>